// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","gateway_headerArrow":"gateway_headerArrow-3k7kc","iframe":"iframe-3016Q"};